import { render, staticRenderFns } from "./ReportAdminEfficiency.vue?vue&type=template&id=0fecde3a&"
import script from "./ReportAdminEfficiency.vue?vue&type=script&lang=js&"
export * from "./ReportAdminEfficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports